/** W73c (D-285): Wischen nach links auf einer Verlaufszeile legt den Loeschen-Knopf frei, wie in der App. Erst ab
 *  deutlicher waagrechter Bewegung (24 px und mehr waagrecht als senkrecht), damit Scrollen und die Zurueck-Geste des
 *  Browsers frei bleiben; senkrecht ab 10 px gehoert die Geste dem Scrollen. Gedrueckt halten (500 ms, hoechstens 10 px
 *  Spiel) oeffnet ein Menue mit „Löschen“. */
export const WISCH_SCHWELLE = 24;
export const SCROLL_SCHWELLE = 10;
export const HALTEN_MS = 500;
export const HALTEN_SPIEL = 10;

export type Richtung = "waagrecht" | "senkrecht" | null;

/** Wem gehoert die Geste nach der Bewegung (dx, dy) seit dem Aufsetzen; null: noch offen. */
export function wischRichtung(dx: number, dy: number, schwelle = WISCH_SCHWELLE): Richtung {
  const x = Math.abs(dx);
  const y = Math.abs(dy);
  if (x >= schwelle && x > y) return "waagrecht";
  if (y >= SCROLL_SCHWELLE && y >= x) return "senkrecht";
  return null;
}

/** Versatz der Zeile beim Ziehen: nur nach links, ab dem Start (0 zu, -breite offen); ueber den Knopf hinaus gedaempft. */
export function wischVersatz(dx: number, start: number, breite: number): number {
  const roh = Math.min(0, start + dx);
  if (roh >= -breite) return roh;
  return -breite - (-breite - roh) / 3;
}

/** Bleibt der Knopf nach dem Loslassen offen: ab der halben Knopfbreite, sonst federt die Zeile zurueck. */
export function wischOffen(versatz: number, breite: number): boolean {
  return versatz <= -breite / 2;
}

/** Hat sich der Finger beim Halten zu weit bewegt (dann kein Menue). */
export function haltenVerworfen(dx: number, dy: number): boolean {
  return Math.hypot(dx, dy) > HALTEN_SPIEL;
}
